import { config } from "../env";
import {
  Delete,
  get,
  getFile,
  patch,
  post,
  postFileUpload,
} from "./helpers/http-handler";

export const getTaskLicenses = (queryRequest: string) =>
  get(`${config.API_URL}/licenses?${queryRequest}`);

export const getSpecificTaskLicense = (id: string) =>
  get(`${config.API_URL}/licenses/${id}`);

export const addTaskLicenses = (payload: object) =>
  post(`${config.API_URL}/licenses`, payload);

export const updateTaskLicenses = (id: string, payload: object) =>
  patch(`${config.API_URL}/licenses/${id}`, payload);

export const deleteTaskLicenses = (id: String) =>
  Delete(`${config.API_URL}/licenses/${id}`);

export const getUpdateActiveStatusLicence = (payload: object) =>
  patch(`${config.API_URL}/licenses/bulk/active-inactive`, payload);

export const getSpecificLicenseHistoryTask = (
  id: string,
  queryRequest: string
) => get(`${config.API_URL}/license-task/${id}/task-history?${queryRequest}`);

export const addAllTaskLicenseTask = (queryRequest: string) =>
  get(`${config.API_URL}/license-task?${queryRequest}`);

export const addSpecificTaskLicenseTask = (id: string) =>
  get(`${config.API_URL}/license-task/${id}`);

export const addTaskLicenseTask = (payload: object) =>
  post(`${config.API_URL}/license-task`, payload);

export const updateTaskLicenseTask = (id: string, payload: object) =>
  patch(`${config.API_URL}/license-task/${id}`, payload);

export const deleteTaskLicenseTask = (id: String) =>
  Delete(`${config.API_URL}/license-task/${id}`);

// crons
export const adminAllCrons = (queryRequest: string) =>
  get(`${config.API_URL}/cron?${queryRequest}`);

export const adminAllCronLogs = (queryRequest: string) =>
  get(`${config.API_URL}/cron/logs?${queryRequest}`);

export const adminAllCronLogsRefresh = (payload: object) =>
  post(`${config.API_URL}/cron/refresh`, payload);

export const complianceTaskImport = (payload: object) =>
  postFileUpload(`${config.API_URL}/compliance-task/import/data`, payload);

export const licenseTaskImport = (payload: object) =>
  postFileUpload(`${config.API_URL}/license-task/import/data`, payload);

export const adminAllCronsConfig = () => get(`${config.API_URL}/cron/config`);

export const addAllCronsConfig = (payload: object) =>
  post(`${config.API_URL}/cron/config`, payload);

export const updateAllCronsConfig = (id: string, payload: object) =>
  patch(`${config.API_URL}/cron/config/${id}`, payload);

//imports

export const getAllLogs = (queryRequest: string) =>
  get(`${config.API_URL}/imports?${queryRequest}`);

export const adminReRunCron = (id: string) =>
  get(`${config.API_URL}/cron/list/cron/vendor/${id}`);

// export const adminReRunCron = (queryRequest: string) =>
// 	get(`${config.API_URL}/cron/list/cron/vendor/?${queryRequest}`);

export const getUpdateActiveStatusLicenceTask = (payload: object) =>
  patch(`${config.API_URL}/license-task/bulk/active-inactive`, payload);

export const downloadLiscenseTask = (queryRequest: string) =>
  get(`${config.API_URL}/license-task/all-documents-zip?${queryRequest}`);

export const updateLicenseTaskOwner = (payload: object) =>
  patch(`${config.API_URL}/license-task/bulk/change-user`, payload);

export const downloadLicenseTaskUpdateTemplate = (
  templateType?: string | null
) => {
  const query = templateType ? `?template_type=${templateType}` : "";

  return getFile(
    `${config.API_URL}/license-task/task/update/template${query}`,
    "Update_License_Task_Template.xlsx"
  );
};
